// Link model for the Aspose.ai top bar, kept apart from the markup so the menu can be
// edited without touching Header.js. Mirrors what the Containerize.Menu service served
// for the "asposeai-en" venture (https://menucdn.containerize.com/asposeai/en.json).

// Rendered as the wide "products" mega menu. `name` gets " AI Agents" appended.
export const PRODUCTS = [
    {href: "https://products.aspose.ai/total/", name: "Aspose.Total"},
    {href: "https://products.aspose.ai/words/", name: "Aspose.Words"},
    {href: "https://products.aspose.ai/cells/", name: "Aspose.Cells"},
    {href: "https://products.aspose.ai/pdf/", name: "Aspose.PDF"},
    {href: "https://products.aspose.ai/slides/", name: "Aspose.Slides"},
    {href: "https://products.aspose.ai/imaging/", name: "Aspose.Imaging"},
    {href: "https://products.aspose.ai/ocr/", name: "Aspose.OCR"},
    {href: "https://products.aspose.ai/font/", name: "Aspose.Font"},
    {href: "https://products.aspose.ai/tex/", name: "Aspose.TeX"},
    {href: "https://products.aspose.ai/html/", name: "Aspose.HTML"},
    {href: "https://products.aspose.ai/diagram/", name: "Aspose.Diagram"},
    {href: "https://products.aspose.ai/video/", name: "Aspose.Video"},
    {href: "https://products.aspose.ai/audio/", name: "Aspose.Audio"},
    {href: "https://products.aspose.ai/note/", name: "Aspose.Note"},
    {href: "https://products.aspose.ai/tasks/", name: "Aspose.Tasks"},
    {href: "https://products.aspose.ai/page/", name: "Aspose.Page"},
    {href: "https://products.aspose.ai/pub/", name: "Aspose.PUB"},
    {href: "https://products.aspose.ai/svg/", name: "Aspose.SVG"},
    {href: "https://products.aspose.ai/email/", name: "Aspose.Email"}
];

// The remaining top-level entries, each with a plain single-column dropdown.
export const SECTIONS = [
    {
        label: "Purchase",
        href: "https://purchase.aspose.ai",
        items: [
            {label: "Pricing", href: "https://purchase.aspose.ai"}
        ]
    },
    {
        label: "Support",
        href: "https://forum.aspose.ai/",
        items: [
            {label: "Free Support", href: "https://forum.aspose.ai"},
            {label: "Blog", href: "https://blog.aspose.ai"}
        ]
    },
    {
        label: "Websites",
        href: "https://websites.aspose.ai/",
        items: [
            {label: "aspose.com", href: "https://websites.aspose.ai/aspose/com"},
            {label: "aspose.net", href: "https://websites.aspose.ai/aspose/net"},
            {label: "aspose.cloud", href: "https://websites.aspose.ai/aspose/cloud"},
            {label: "aspose.app", href: "https://websites.aspose.ai/aspose/app"},
            {label: "aspose.org", href: "https://websites.aspose.ai/aspose/org"},
            {label: "aspose.ai", href: "https://websites.aspose.ai/aspose/ai"},
            {label: "groupdocs.com", href: "https://websites.aspose.ai/groupdocs/com"},
            {label: "groupdocs.cloud", href: "https://websites.aspose.ai/groupdocs/cloud"},
            {label: "groupdocs.app", href: "https://websites.aspose.ai/groupdocs/app"},
            {label: "conholdate.com", href: "https://websites.aspose.ai/conholdate/com"},
            {label: "conholdate.app", href: "https://websites.aspose.ai/conholdate/app"}
        ]
    },
    {
        label: "About",
        href: "https://about.aspose.ai/",
        items: [
            {label: "About Us", href: "https://about.aspose.ai/"},
            {label: "Contact", href: "https://about.aspose.ai/contact"},
            {label: "Legal", href: "https://about.aspose.ai/legal"},
            {label: "Metrics", href: "https://metrics.aspose.ai/"}
        ]
    }
];

// Bottom bar links.
export const FOOTER_LINKS = [
    {label: "Home", href: "https://www.aspose.ai/"},
    {label: "Products", href: "https://products.aspose.ai"},
    {label: "Free Support", href: "https://forum.aspose.ai"},
    {label: "Blog", href: "https://blog.aspose.ai/"},
    {label: "Websites", href: "https://websites.aspose.app/"},
    {label: "About", href: "https://about.aspose.ai/"}
];

export const FOOTER_LEGAL = [
    {label: "Privacy Policy", href: "https://about.aspose.app/legal/privacy-policy/"},
    {label: "Terms of Service", href: "https://about.aspose.ai/legal/tos/"},
    {label: "Contact", href: "https://about.aspose.ai/contact/"}
];
